/*! free-product-guard.js
 *  Defense-in-depth for $0 ("free") products on the storefront.
 *  This theme has NO tiered-gift system, so a cart should never legitimately
 *  contain a $0 line item. This guard therefore:
 *    1. Auto-removes any $0 line item from the cart (on load + after every cart
 *       mutation), so a free product can never persist in the cart.
 *    2. Blocks checkout when the cart total is $0 (an all-free / empty cart).
 *  Works alongside the Liquid guards that hide $0 products from collections,
 *  search, and redirect their product pages.
 */
(function () {
  'use strict';
  if (!window.fetch) return; // very old browser — Liquid guards still apply
  var _fetch = window.fetch.bind(window);
  var OWN = { 'Content-Type': 'application/json', 'X-FPG': '1' };
  var lastTotal = null;      // last known cart total_price (cents)
  var purging   = false;

  function getCart() {
    return _fetch('/cart.js', { headers: { 'X-FPG': '1' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (cart) lastTotal = cart.total_price; return cart; })
      .catch(function () { return null; });
  }

  // Remove every $0 line item from the cart, then refresh lastTotal.
  function purgeFreeItems() {
    if (purging) return Promise.resolve(null);
    purging = true;
    return getCart().then(function (cart) {
      if (!cart) return null;
      var updates = {}, found = false;
      (cart.items || []).forEach(function (it) {
        if (it.price === 0 || it.final_line_price === 0) { updates[it.key] = 0; found = true; }
      });
      if (!found) return cart;
      return _fetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin', headers: OWN,
        body: JSON.stringify({ updates: updates })
      }).then(getCart);
    }).catch(function () { return null; })
      .then(function (c) { purging = false; return c; });
  }

  // After any non-own cart mutation (fetch), purge $0 items.
  window.fetch = function () {
    var args = arguments;
    var url  = (typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url)) || '';
    var hdrs = args[1] && args[1].headers;
    var isOwn = hdrs && (hdrs['X-FPG'] === '1' || (hdrs.get && hdrs.get('X-FPG') === '1'));
    var p = _fetch.apply(this, args);
    if (!isOwn && /\/cart\/(add|change|update)/.test(url)) { p.then(function () { purgeFreeItems(); }); }
    return p;
  };

  // After any cart mutation via XHR (jQuery $.ajax / $.post), purge $0 items.
  (function () {
    var _open = XMLHttpRequest.prototype.open;
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this._fpgUrl = u; return _open.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      if (this._fpgUrl && /\/cart\/(add|change|update)/.test(this._fpgUrl)) {
        this.addEventListener('load', function () { purgeFreeItems(); });
      }
      return _send.apply(this, arguments);
    };
  })();

  // Checkout guard: block ONLY when we know the cart total is $0 (no payable
  // product). For any positive total we do not interfere with normal checkout.
  document.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest('[name="checkout"]') : null;
    if (!btn) return;
    if (lastTotal === 0) {
      e.preventDefault();
      e.stopImmediatePropagation();
      try { window.alert('Your cart total is $0.00 — add a product to your order before checking out.'); } catch (_) {}
      getCart(); // re-check in case it changed under us
    }
  }, true);

  // Initial sweep on load (covers items added before this script ran, or a cart
  // built via a /cart permalink).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', purgeFreeItems);
  } else {
    purgeFreeItems();
  }
})();
